import api from './api';

export const defaultPublicSettings = {
  companyName: 'Algoryn',
  tagline: 'Transforming Ideas into Digital Reality',
  contactEmail: 'hello@algoryn.com',
  contactPhone: '+91 9876543210',
  address: 'Noida, India',
  facebook: 'https://facebook.com/algoryn',
  twitter: 'https://twitter.com/algoryn',
  linkedin: 'https://linkedin.com/company/algoryn',
  github: 'https://github.com/algoryn',
  instagram: 'https://instagram.com/algoryn',
  seoTitle: 'Algoryn - IT Consulting & Digital Transformation',
  seoDescription: 'Leading IT consulting company offering web development, mobile apps, cloud solutions, and digital transformation services.'
};

export const getPublicSettings = async () => {
  const res = await api.get('/settings/public');
  return { ...defaultPublicSettings, ...res.data.settings };
};
